const visibility = ref(false)
export const url = ref('')
export const loading = ref('')
export const payPro = { visibility, loading }
